import { call, put, takeEvery } from "redux-saga/effects"
import { DLogin } from "apis/DLogin"
import { callApi } from "sagas/Api"
import { GET_THIRDPARTY_INFO, storeThirdPartyInfo } from "actions"
import { getThirdPartyInfo } from "apis/ThirdPartyInfo"
import { moveToTop } from "locale"

export function* handleGetThirdPartyInfo() {
  yield takeEvery(GET_THIRDPARTY_INFO, execGetThirdPartyInfo)
}

export function* execGetThirdPartyInfo() {
  const { payload, error } = yield call(callApi, getThirdPartyInfo)
  if (payload && !error) {
    yield put(storeThirdPartyInfo(payload))
  } else {
    if (error.message === "invalid token") {
      // リフレッシュトークンが無効な場合
      yield call(DLogin, { prompt: false })
    } else if (error.message === "dauth error") {
      // サーバエラーなどでトークンリフレッシュに失敗した場合
      yield call(moveToTop)
    } else {
      // APIの処理に失敗した場合
      yield call(moveToTop)
    }
  }
}
